import type { HoneycombAffiliateWindow } from "./honeycomb";

export interface AffiliateWindow extends Window {
  honeycombAffiliate?: HoneycombAffiliateWindow;
}

export const getAffiliateWindow = () => {
  if (typeof window !== undefined) {
    return window as AffiliateWindow;
  }
  return undefined;
};
